export default "__VITE_ASSET__WCJ$KRUN__"